var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownGrayPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDownGrayPayment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5022256,3.55524107 C10.5166343,3.78999161 10.438893,4.02929758 10.2690017,4.21489131 L4.73512256,10.2602458 C4.4553529,10.5658735 3.98079456,10.5868356 3.67516686,10.3070659 C3.65887871,10.2921559 3.64325679,10.276534 3.62834673,10.2602458 C3.31512862,9.91807816 3.31512862,9.39334258 3.62834673,9.05117492 L8.6592897,3.55524107 L3.62834673,-1.94069277 C3.31512862,-2.28286043 3.31512862,-2.80759601 3.62834673,-3.14976367 C3.90811639,-3.45539138 4.38267472,-3.47635347 4.68830243,-3.1965838 C4.70459058,-3.18167374 4.7202125,-3.16605182 4.73512256,-3.14976367 L10.2690017,2.89559084 C10.438893,3.08118457 10.5166343,3.32049053 10.5022256,3.55524107 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowDownGrayPayment",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    transform: "translate(6.948674, 3.555241) rotate(90.000000) translate(-6.948674, -3.555241) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGrayPayment);
export default __webpack_public_path__ + "static/media/arrowDownGrayPayment.a4976dd228f273678cf63eafc350144d.svg";
export { ForwardRef as ReactComponent };